var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    className: "cls-1",
    d: "M17.1,6.1l-.9-.6v13.2h1.8V4.7l-.9,1.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    className: "cls-1",
    d: "M11.2,7.6v11.1h1.8V5.9l-1.8,1.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    className: "cls-1",
    d: "M7,12l-.9-.4v7.2h1.8v-7.6l-.9,.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    className: "cls-1",
    d: "M1.1,10.8v8h1.7V9.1l-1.7,1.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    className: "cls-1",
    d: "M17.5,0l-3.7,.4,1.2,1.3L6.8,9.1,2.7,6.2,0,9l.5,.5,2.3-2.4,4,2.8L15.5,2.2l1.2,1.4,.8-3.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelStatistics);
export default __webpack_public_path__ + "static/media/channel-statistics.bce1315e53e7d9f0137a0db29e9e678e.svg";
export { ForwardRef as ReactComponent };